import { Component } from '@angular/core';
import { IonicPage, NavParams } from 'ionic-angular';
import { NavController, ModalController, AlertController } from 'ionic-angular';
import * as moment from 'moment';

import { VariablesProvider } from '../../providers/variables/variables';
import { FuncionesProvider } from '../../providers/funciones/funciones';
import { PicajesPage } from '../../pages/picajes/picajes';

import { AvisoslinPage } from '../../pages/avisoslin/avisoslin';

import { CalendarioPage } from '../../pages/calendario/calendario';
import { LoginPage } from '../../pages/login/login';
import { CalendarModal, CalendarModalOptions, DayConfig, CalendarResult } from "ion2-calendar";
import { CalendarComponentOptions } from 'ion2-calendar'
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import { ListPage } from '../list/list';
import { HorasUtil } from '../../providers/horas/horas';

/**
 * Generated class for the ObrasPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-turnos',
  templateUrl: 'turnos.html',
})
export class TurnosPage {

  diasdefiesta;
  myForm: FormGroup;
  myForm1: FormGroup;
  myForm2: FormGroup;
  misapp: Array<{title: string, descripcion: string, imagen: string , component: any}>;
  formulario = {
    codigo1: "",
    nombre1: "",
    hora_entrada1: "",
    cortesia1: "",
    hora_salida1: "",
    hora_aviso1: "",
    l1: "",
    m1: "",
    x1: "",
    j1: "",
    v1: "",
    s1: "",
    d1: "",
    almuerzo1: "",
    cena1: ""
  }
  resultado;
  date: string;
  type: 'string'; // 'string' | 'js-date' | 'moment' | 'time' | 'object'
  minuto = []; //= {valor: "1",color: "1"}
  color = []; //= {valor: "1",color: "1"}
  cabecera = []; //= {valor: "1",color: "1"}
  turnos;
  valo="654321123456" ;
  formulario2 = {valor: ""}
  obrasKeys;
  values:Array<string> = [];

   
  asignaciones: { [dia: number]: { [turnoId: number]: string[] } } = {};


  turnos2 = [
    {
      nombre: 'Turno 1',
      fecha: '2025-05-21',
      horaInicio: '09:00',
      trabajadores: ['Juan', 'Ana']
    },
    {
      nombre: 'Turno 2',
      fecha: '2025-05-21',
      horaInicio: '11:36',
      trabajadores: ['Luis']
    },
    {
      nombre: 'Turno 3',
      fecha: '2025-05-22',
      horaInicio: '14:12',
      trabajadores: []
    }
  ];
  trabajadores = [
    { id: 't1', nombre: 'Juan' },
    { id: 't2', nombre: 'Ana' },
    { id: 't3', nombre: 'Luis' },
  ];

modo: any[] = [
    { 
      // ... otras propiedades del turno
      valor: 'automatico' // Valor por defecto para el primer turno
    },
    { 
      // ... otras propiedades del turno
      valor: 'manual' // Valor por defecto para el segundo turno
    },
  ]
  

  diasSemana = ['L', 'M', 'X', 'J', 'V', 'S', 'D'];
  anioActual = 2025;
  mesActual = 8; // Mayo (0 = enero)
  calendario: Date[][] = [];
  

  mesSeleccionado: string = new Date().toISOString();
  diasDelMes: { dia: number, nombreDia: string }[] = [];

  actualizarDiasDelMes() {
    const fecha = new Date(this.mesSeleccionado);
    const año = fecha.getFullYear();
    const mes = fecha.getMonth();
  
    const primeros7dias: { dia: number, nombreDia: string }[] = [];
  
    for (let i = 1; i <= 7; i++) {
      const f = new Date(año, mes, i);
      const nombreDia = f.toLocaleDateString('es-ES', { weekday: 'long' });
      primeros7dias.push({ dia: i, nombreDia });
    }
  
    this.diasDelMes = primeros7dias;
  }
  abrirAsignacion(dia: number, turno: any) {
    // Aquí implementarías el modal o alerta para asignar trabajadores
    console.log(`Asignar trabajadores al día ${dia}, turno ${turno.nombre}`);
  }

  constructor(
  	public navParams: NavParams,
    public fb: FormBuilder,
    private alertCtrl: AlertController,
    public modalCtrl: ModalController,
  	public navCtrl: NavController,
    public funciones:FuncionesProvider,
  	public variables:VariablesProvider
    ) {                    

      
      
      this.variables.btatras = true;
      var sum = 0;
      var horas=0;
  
      this.myForm = this.fb.group({

      id: [''],
      nombre: ['' ],
      hora_entrada: ['', HorasUtil.validador],
      cortesia: [''],
      hora_salida: ['', HorasUtil.validador],
      hora_aviso: ['', HorasUtil.validador],
      aviso1: [''],
      texto1: [''],
      aviso2: [''],
      texto2: [''],
      aviso3: [''],
      texto3: [''],
      aviso4: [''],
      texto4: [''],
      l: [''],
      m: [''],
      x: [''],
      j: [''],
      v: [''],
      s: [''],
      d: [''],
      almuerzo: [''],
      cena: ['']

     });

 this.myForm1 = this.fb.group({

      id1: ['', [Validators.required]],
      nombre1: ['', [Validators.required]],
      hora_entrada1: ['', [Validators.required]],
      cortesia: [''],      
      hora_salida1: ['', [Validators.required]],
      hora_aviso1: ['', [Validators.required]],
      aviso1: [''],
      texto1: [''],
      aviso2: [''],
      texto2: [''],
      aviso3: [''],
      texto3: [''],
      aviso4: [''],
      texto4: [''],
      l1: ['', [Validators.required]],
      m1: ['', [Validators.required]],
      x1: ['', [Validators.required]],
      j1: ['', [Validators.required]],
      v1: ['', [Validators.required]],
      s1: ['', [Validators.required]],
      d1: ['', [Validators.required]],
      almuerzo1: ['', [Validators.required]],
      cena1: ['', [Validators.required]]
     });
   

    this.obtenerturnos(this.valo);

  }

  ngOnInit() {
    this.calendario = this.getCalendarioDelMes(this.anioActual, this.mesActual);
 
  }

  getCalendarioDelMes(anio: number, mes: number): Date[][] {
    const semanas: Date[][] = [];
    const primerDia = new Date(anio, mes, 1);
    const ultimoDia = new Date(anio, mes + 1, 0);
  
    const inicio = new Date(primerDia);
    inicio.setDate(primerDia.getDate() - ((primerDia.getDay() + 6) % 7));
  
    let diaActual = new Date(inicio);
  
    while (diaActual <= ultimoDia || diaActual.getDay() !== 1) {
      const semana: Date[] = [];
      for (let i = 0; i < 7; i++) {
        semana.push(new Date(diaActual));
        diaActual.setDate(diaActual.getDate() + 1);
      }
      semanas.push(semana);
    }
  
    return semanas;
  }
  

  obtenerTurnosDelDia(dia: Date) {
    const fechaStr = dia.toISOString().split('T')[0];
    return this.turnos2.filter(t => t.fecha === fechaStr);
  }

   buscarturnos(){
     var neutro;
    if (this.formulario2.valor != ""){
      neutro = this.formulario2.valor;
     }else{
      neutro = this.valo;
    }
    //console.log("Vamos a buscar :" + neutro);
    this.funciones.obtieneturnos(neutro).then(
          data => {

          this.turnos = data;

          //console.log(this.turnos);

          }
      )
      .catch(
        error => {
          console.log(error);
        }
      )
  }

  async asignarTrabajadores(turno: any) {
    const alert = await this.alertCtrl.create({
      inputs: this.trabajadores.map(t => ({
        name: t.nombre,
        type: 'checkbox',
        label: t.nombre,
        value: t.nombre,
        checked: turno.trabajadores.includes(t.nombre),
      })),
      buttons: [
        { text: 'Cancelar', role: 'cancel' },
        {
          text: 'Aceptar',
          handler: (seleccionados) => {
            turno.trabajadores = seleccionados;
          },
        },
      ],
    });

    await alert.present();
  }


  obtenerturnos(filtro){

    this.funciones.obtieneturnos(filtro).then(
          data => {

          this.turnos = data;


          }
      )
      .catch(
        error => {
          console.log(error);
        }
      )
  }






   editarturnos(index){

    if (!this.normalizarHorasTurno(index)) {
      this.avisoHoraInvalida();
      return;
    }

    var hora_aviso;
    
    hora_aviso=this.turnos[index].HORA_AVISO;
    if (hora_aviso=="") {
      hora_aviso=" ";
    }
    
    var hora_salida;
    
    hora_salida=this.turnos[index].HORA_SALIDA;
    if (hora_salida=="") {
      hora_salida=" ";
    }

    //alert(this.turnos[index].MODO)

    

    this.funciones.editarturnos(

      this.turnos[index].ID,
      this.turnos[index].NOMBRE,
      this.turnos[index].HORA_ENTRADA,
      this.turnos[index].CORTESIA,
      hora_salida,
      hora_aviso,
      this.turnos[index].L,
      this.turnos[index].M,
      this.turnos[index].X,
      this.turnos[index].J,
      this.turnos[index].V,
      this.turnos[index].S,
      this.turnos[index].D,
      this.turnos[index].ALMUERZO,
      this.turnos[index].CENA,
      this.turnos[index].MODO
      ).then(
          data => {
            console.log(data);
            this.turnos = data;
            this.obtenerturnos(this.valo);
          }
      )
      .catch(
        error => {
          console.log(error);
        }
      )
     
  }

  registro(){

    if (!this.normalizarHorasFormulario()) {
      this.avisoHoraInvalida();
      return;
    }

    var hora_aviso;
    
    hora_aviso=this.formulario.hora_aviso1;
    if (hora_aviso=="") {
      hora_aviso=" ";
    }
    
    var hora_salida;
    
    hora_salida=this.formulario.hora_salida1;
    if (hora_salida=="") {
      hora_salida=" ";
    }


   this.funciones.grabarturnos(
     this.formulario.nombre1,
     this.formulario.hora_entrada1,
     this.formulario.cortesia1,     
     hora_salida,
     hora_aviso,
     this.formulario.l1,
     this.formulario.m1,
     this.formulario.x1,
     this.formulario.j1,
     this.formulario.v1,
     this.formulario.s1,
     this.formulario.d1,
     this.formulario.almuerzo1,
     "0" //this.formulario.cena1
     ).then(
     data => {
          this.resultado = data;
          //console.log(data);

          this.obtenerturnos(this.valo);

         this.formulario.nombre1="";
         this.formulario.hora_entrada1="";
         this.formulario.cortesia1="";
         this.formulario.hora_salida1="";
         this.formulario.hora_aviso1="";
         this.formulario.l1="";
         this.formulario.m1="";
         this.formulario.x1="";
         this.formulario.j1="";
         this.formulario.v1="";
         this.formulario.s1="";
         this.formulario.d1="";
         this.formulario.almuerzo1="";
         this.formulario.cena1="";
           
        })


  }

   borrar(codigo,nombre){

   

      let alert = this.alertCtrl.create({
          title: 'Borrar.',
          message: '¿Confirma borrar la turno? '  + codigo + ' -> ' + nombre,
          cssClass: 'alertCustomCss',
          buttons: [{
              text: 'No',
              role: 'No',
              handler: () => {  }
            },{
              text: 'Si',
              handler: () => {


               this.funciones.delturnos(codigo).then(
                   data => {
                    
                    this.obtenerturnos(this.valo);

                  })           
              }
            }
          ]
        });
        alert.present();
     
  }


  salir(){
    this.navCtrl.push(ListPage);
 }
 
  valChange(campo:string, value:string, index:number):void{
      
      //alert("Campo->" + campo + "valor->" + value + "lugar->" + index)

      switch (campo) {
         case "ID":
           this.turnos[index].ID = value;
           break;
         case "NOMBRE":
           this.turnos[index].NOMBRE = value;
           break;
         case "HORA_ENTRADA":
           this.turnos[index].HORA_ENTRADA = value;
           break;
         case "CORTESIA":
           this.turnos[index].CORTESIA = value;
           break;
          case "HORA_SALIDA":
           this.turnos[index].HORA_SALIDA = value;
           break;
         case "HORA_AVISO":
           this.turnos[index].HORA_AVISO = value;
           break;
         case "L":
           this.turnos[index].L = value;
           break;
         case "M":
           this.turnos[index].M = value;
           break;
         case "X":
           this.turnos[index].X = value;
           break;
         case "J":
           this.turnos[index].J = value;
           break;
         case "V":
           this.turnos[index].V = value;
           break;
         case "S":
           this.turnos[index].S = value;
           break;
         case "D":
           this.turnos[index].D = value;
           break;
         case "ALMUERZO":
           this.turnos[index].ALMUERZO = value;
           break;
         case "CENA":
           this.turnos[index].CENA = value;
           break;
         case "MODO":
          this.turnos[index].MODO = value;
          break;       
       
         
         default:
           // code...
           break;
       }
     
    }




  openModalWithParams(id, nombre,i) {

      //console.log("Este es el ID marcado =" + id);

      let myModal = this.modalCtrl.create(AvisoslinPage, {
              'caption':  'Avisos del turno ' + nombre,        
              'id': i,
              'rsx': this.turnos,
              'tabla': "avisoslin"
            }
            );

            myModal.onDidDismiss((data: any) => { 
               this.obtenerturnos(this.valo);
            }); 
            myModal.present();
  }

  normalizarHoraFormulario(campo: string, control: string): void {
    const valor = this.formulario[campo];
    const normalizada = HorasUtil.normalizar(valor);
    const controlFormulario = this.myForm.controls[control];

    if (normalizada === null) {
      controlFormulario.setErrors({ horaInvalida: true });
      return;
    }

    this.formulario[campo] = normalizada;
    controlFormulario.setValue(normalizada, { emitEvent: false });
    controlFormulario.setErrors(null);
  }

  private normalizarHorasFormulario(): boolean {
    const campos = [
      { campo: 'hora_entrada1', control: 'hora_entrada' },
      { campo: 'hora_salida1', control: 'hora_salida' },
      { campo: 'hora_aviso1', control: 'hora_aviso' }
    ];
    let valido = true;
    campos.forEach(item => {
      const normalizada = HorasUtil.normalizar(this.formulario[item.campo]);
      if (normalizada === null) {
        this.myForm.controls[item.control].setErrors({ horaInvalida: true });
        valido = false;
      } else {
        this.formulario[item.campo] = normalizada;
        this.myForm.controls[item.control].setValue(normalizada, { emitEvent: false });
        this.myForm.controls[item.control].setErrors(null);
      }
    });
    return valido;
  }

  normalizarHoraTurno(campo: string, index: number): void {
    const normalizada = HorasUtil.normalizar(this.turnos[index][campo]);
    this.turnos[index][campo] = normalizada === null ? this.turnos[index][campo] : normalizada;
    this.turnos[index].__horaInvalida = normalizada === null;
  }

  private normalizarHorasTurno(index: number): boolean {
    const campos = ['HORA_ENTRADA', 'HORA_SALIDA', 'HORA_AVISO'];
    let valido = true;
    campos.forEach(campo => {
      const normalizada = HorasUtil.normalizar(this.turnos[index][campo]);
      if (normalizada === null) {
        valido = false;
      } else {
        this.turnos[index][campo] = normalizada;
      }
    });
    this.turnos[index].__horaInvalida = !valido;
    return valido;
  }

  private avisoHoraInvalida(): void {
    this.alertCtrl.create({
      title: 'Hora no válida',
      message: 'Introduzca la hora con formato HH:MM. Por ejemplo: 09:15.',
      buttons: ['Aceptar']
    }).present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/turnos/turnos.ts